import React from 'react';
import styles from './ExpandedCard.module.scss';
import { Icon } from 'antd';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import cn from 'classnames';

const ExpandedCard = ({
  heading = '',
  description = '',
  icon,
  expanded = true,
  handleExpanded,
  disabled = false,
  children,
}) => {
  const iconExpanded = <Icon type={expanded ? 'caret-up' : 'caret-down'} />;

  const handleClick = () => handleExpanded?.();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.containerTitleRow}>
          <div className={styles.titleRow}>
            {icon && <div className={styles.icon}>{icon}</div>}
            <div
              className={cn(styles.heading, {
                [styles.disabledText]: disabled,
              })}
            >
              {heading}
            </div>
          </div>
          {!disabled && (
            <RoundedButton
              className={styles.expandedButton}
              onClick={handleClick}
              text={iconExpanded}
            />
          )}
        </div>

        {description && (
          <div
            className={cn(styles.description, {
              [styles.disabledText]: disabled,
            })}
          >
            {description}
          </div>
        )}
      </div>

      {expanded && children}
    </div>
  );
};

export default ExpandedCard;
